import React from "react";
import {
  Paper,
  Text,
  Group,
  Image,
} from "@mantine/core";

export function Banner() {
  return (
    <Paper
      radius="sm"
      shadow="xs"
      style={{
        padding: "6px",
        zIndex: 99999,
        backgroundColor: "#018EA2",
        backgroundImage: 'url("/banner.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Group align="center">
        <a
          href="https://www.portphillip.vic.gov.au/"
        >
          <Image
            src="https://intranet.portphillip.vic.gov.au/media/zxto0ego/copplogo.png?mode=min&height=160&rnd=132413124847230000"
            alt="City of Port Phillip"
            width={40}
            height={40}
          />
        </a>

        <Text ml={10} size="lg" fw="500" style={{ color: "white" }}>
          City of Port Phillip
        </Text>
        <Text mr={5} ml={5} size="lg" fw="500" style={{ color: "white" }}>
          |
        </Text>
        <Text size="lg" fw="500" style={{ color: "white" }}>
          Development Activity Model{" "}
        </Text>
      </Group>
    </Paper>
  );
}
